import React from 'react';

export function PasswordToggleButton({ visible, onToggle }) {
    return (
        <button
            type="button"
            className="auth-input-wrap__toggle"
            onClick={onToggle}
            aria-label={visible ? '비밀번호 숨기기' : '비밀번호 표시'}
            tabIndex={-1}
        >
            {visible ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
                    <circle cx="12" cy="12" r="3" />
                </svg>
            ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 3l18 18" />
                    <path d="M10.58 10.58a2 2 0 0 0 2.83 2.83" />
                    <path d="M9.88 4.24A10.94 10.94 0 0 1 12 4c6.5 0 10 7 10 7a13.16 13.16 0 0 1-3.06 3.94M6.1 6.1A13.24 13.24 0 0 0 2 11s3.5 7 10 7a10.93 10.93 0 0 0 4.02-.76" />
                </svg>
            )}
        </button>
    );
}
